import { LoanQuoteDataBaseField } from './LoanQuoteBaseField';
import { Controller } from 'react-hook-form';
import { InputGroup } from '@blueprintjs/core';
import { LoanQuoteDataFieldCommonProps } from './types';
import { LoanQuoteDataFormFieldPath } from '../QuoteDataFormSchema';
import { defaultFormatter } from '../../../../forms/generic-fields/common';

interface LoanQuoteTextFieldProps extends LoanQuoteDataFieldCommonProps {
  name: LoanQuoteDataFormFieldPath;
  formatter?: (value: unknown) => string;
  errorMessage?: string;
}

export const LoanQuoteTextField: React.FC<LoanQuoteTextFieldProps> = ({
  name,
  formatter = defaultFormatter,
  errorMessage,
  ...props
}) => (
  <Controller
    name={name}
    render={({ field, fieldState }) => (
      <LoanQuoteDataBaseField
        errorMessage={
          errorMessage
            ? errorMessage
            : fieldState.invalid
            ? fieldState.error?.message
            : undefined
        }
        valueElement={formatter(field.value as never)}
        inputElement={
          <InputGroup
            type="text"
            name={field.name}
            onChange={field.onChange}
            onBlur={field.onBlur}
            value={field.value ?? ''}
            inputRef={field.ref}
            fill
          />
        }
        {...props}
      />
    )}
  />
);
